import _parseInt from 'lodash/parseInt';
import APPCONFIG from '../../constants/Config';
import {
  REINIT_STATE,
  GET_USERS_LIST,
  GET_USERS_LIST_SUCCESS,
  GET_USERS_LIST_ERROR,
  GET_USER,
  GET_USER_SUCCESS,
  GET_USER_ERROR,
  ADD_USER,
  ADD_USER_SUCCESS,
  ADD_USER_ERROR,
  UPDATE_USER,
  UPDATE_USER_SUCCESS,
  UPDATE_USER_ERROR,
  DELETE_USER,
  DELETE_USER_SUCCESS,
  DELETE_USER_ERROR,
} from '../../constants/ActionTypes';
// Model
/* eslint-disable import/named */
import { deserialize } from '../../models/user';
/* eslint-enable import/named */

const initialSettings = APPCONFIG.user;
const user = (state = initialSettings, action) => {
  let key;
  switch (action.type) {
    // REINIT STATE
    case REINIT_STATE:
      key = null;
      if (action.target === 'fullUser') {
        return {
          ...state,
          current: { ...initialSettings.current },
          add: { ...initialSettings.add },
          update: { ...initialSettings.update },
          delete: { ...initialSettings.delete },
        };
      }
      switch (action.target) {
        case 'currentUser':
          key = 'current';
          break;
        case 'addUser':
          key = 'add';
          break;
        case 'updateUser':
          key = 'update';
          break;
        default:
          break;
      }
      if (key) {
        return {
          ...state,
          [key]: {
            ...initialSettings[key],
          },
        };
      }
      return state;
    // LIST
    case GET_USERS_LIST:
      return {
        ...state,
        list: {
          ...state.list,
          loading: true,
          error: null,
          elements: {
            ...state.list.elements,
            data: null,
          },
        },
      };
    case GET_USERS_LIST_ERROR:
      return {
        ...state,
        list: {
          ...state.list,
          loading: false,
          error: action.error,
        },
      };
    case GET_USERS_LIST_SUCCESS:
      return {
        ...state,
        list: {
          ...state.list,
          loading: false,
          elements: {
            ...state.list.elements,
            data: deserialize(action.data.data),
            pageNumber: _parseInt(action.data.page_number),
            pageSize: _parseInt(action.data.page_size),
            totalEntries: _parseInt(action.data.total_entries),
            totalPages: _parseInt(action.data.total_pages),
          },
        },
      };
    // GET
    case GET_USER:
      return {
        ...state,
        current: {
          ...state.current,
          loading: true,
          data: null,
          error: null,
        },
      };
    case GET_USER_ERROR:
      return {
        ...state,
        current: {
          ...state.current,
          loading: false,
          error: action.error,
        },
      };
    case GET_USER_SUCCESS:
      return {
        ...state,
        current: {
          ...state.current,
          loading: false,
          data: deserialize(action.data.data),
        },
      };
    // ADD
    case ADD_USER:
      return {
        ...state,
        add: {
          ...state.add,
          error: null,
        },
      };
    case ADD_USER_ERROR:
      return {
        ...state,
        add: {
          ...state.add,
          added: false,
          error: action.error,
        },
      };
    case ADD_USER_SUCCESS:
      return {
        ...state,
        add: {
          ...state.add,
          added: true,
        },
      };
    // UPDATE
    case UPDATE_USER:
      return {
        ...state,
        update: {
          ...state.update,
          updated: false,
          error: null,
        },
      };
    case UPDATE_USER_ERROR:
      return {
        ...state,
        update: {
          ...state.update,
          error: action.error,
        },
      };
    case UPDATE_USER_SUCCESS:
      return {
        ...state,
        update: {
          ...state.update,
          updated: true,
        },
      };
    // DELETE
    case DELETE_USER:
      return {
        ...state,
        delete: {
          ...state.delete,
          deleted: false,
          error: null,
        },
      };
    case DELETE_USER_ERROR:
      return {
        ...state,
        delete: {
          ...state.delete,
          error: action.error,
        },
      };
    case DELETE_USER_SUCCESS:
      return {
        ...state,
        delete: {
          ...state.delete,
          deleted: true,
        },
      };
    default:
      return state;
  }
};

export default user;



// WEBPACK FOOTER //
// ./reducers/user/user.js